<template>
  <FlotoDropdownPicker
    v-if="!disabled"
    v-model="currentValue"
    as-input
    multiple
    :options="options"
  />
  <span v-else>
    {{
      currentValue && (currentValue || []).length > 0
        ? (
            currentValue.map(
              (v) => (options.find((o) => o.key === v) || {}).text
            ) || []
          ).join(', ')
        : '---'
    }}
  </span>
</template>

<script>
import Range from 'lodash/range'
import Moment from 'moment'
import { getRootPluaralTranslator } from '@utils/get-module-translator'

const __tc = getRootPluaralTranslator()

export default {
  name: 'MonthInput',
  model: { event: 'change' },
  props: {
    value: { type: Number, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  data() {
    this.options = []
    Range(1, 13).forEach((r) => {
      this.options.push({
        text: __tc(
          Moment(`${r}`, 'M')
            .format('MMMM')
            .toLowerCase()
        ),
        key: r,
      })
    })
    // this.options.push({
    //   text: Moment(`${0}`, 'M').format('MMM'),
    //   key: 0,
    // })
    return {}
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('change', v)
      },
    },
  },
}
</script>
